import React from "react";

export default function Introduction() {
  return (
    <section className="relative mt-10 sm:mt-4 lg:mt-7   flex flex-col-reverse justify-center items-center  sm:flex-row   sm:items-start lg:w-5/6 lg:mx-auto  ">
      
      <div className=" my-10 lg:my-0 w-5/6 sm:w-full lg:w-full  xl:w-4/6 2xl:w-4/6">
        <img className="rounded-lg " src="assets/klinikdepan.jpg" alt="" />
      </div>
      <div className="relative sm:mt-9 sm:w-5/6 sm:space-y-4 mt-4 lg:mt-0 px-8 space-y-5 2xl:px-0    2xl:my-0 2xl:space-y-8 text-justify lg:ml-10 xl:ml-24 2xl:ml-44 ">
        <h3 className=" text-blue-500 font-semibold min-[1920px]:text-lg">Selamat Datang!</h3>
        <h1 className="text-3xl sm:text-4xl 2xl:text-6xl font-bold text-start">
          Klinik Pratama Mora Medika
        </h1>
        <p className="text-gray-500 xl:text-lg min-[1920px]:text-xl">
          Klinik Pratama “Mora Medika” merupakan salah satu klinik kesehatan
          yang melayani 24 jam. Klinik ini berdiri pada 30 Oktober 2009 lalu
          berubah menjadi CV Mora Asi Sejahtera Akta Notaris no.3 pada tanggal
          20 Oktober 2017.
        </p>
        <p className="text-gray-500 xl:text-lg min-[1920px]:text-xl">
          Klinik Mora Medika memiliki visi menjadi Klinik yang mampu memberikan
          pelayanan terbaik, berkualitas dan professional kepada masyarakat
          sekitar serta dengan misi mengutamakan kepercayaan dan kepuasan pasien
          dengan memberikan pelayanan yang prima.
        </p>

        <div className=" sm:flex sm:justify-end cursor-pointer ">
          <button className="mt-5 sm:mt-4 lg:mt-0 w-full px-3 py-4 mb-5 sm:w-auto bg-blue-700 rounded-lg sm:px-4 sm:py-3 text-white hover:bg-blue-900 shadow-sm min-[1920px]:text-lg">
            <a href="#facilities">Lihat Fasilitas</a>
          </button>
        </div>
      </div>
    </section>
  );
}
